/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sku: NonNullable<unknown> }} Error_Shop_Variant_Not_SellableInputs */

const vi_error_shop_variant_not_sellable = /** @type {(inputs: Error_Shop_Variant_Not_SellableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`SKU ${i?.sku} đang ngừng bán hoặc không cho bán lẻ nên chưa thêm vào nhóm được.`)
};

/**

* @param {Error_Shop_Variant_Not_SellableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_variant_not_sellable = /** @type {((inputs: Error_Shop_Variant_Not_SellableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Variant_Not_SellableInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_variant_not_sellable(inputs)
});